import clsx from "clsx"
import { ComponentPropsWithoutRef, ReactNode } from "react"
import { ChipRoot } from "./styles"

interface IChipProps extends ComponentPropsWithoutRef<"div"> {
  backgroundColor?: string
  textColor?: string
  size?: "small" | "medium" | "large"
  variant?: "filled" | "outlined"
  iconSrc?: string
  iconAlt?: string
  children?: ReactNode
}

export const Chip = ({
  backgroundColor,
  // textColor,
  size = "small",
  variant = "outlined",
  iconSrc,
  iconAlt,
  children,
  className,
  ...chipProps
}: IChipProps) => {
  const textColorStyle =
    backgroundColor?.toLocaleLowerCase() === "#ffffff" ? "#000000" : "#ffffff"

  const chipRootStyle =
    backgroundColor && variant === "filled"
      ? {
          borderColor: backgroundColor,
          backgroundColor: backgroundColor,
          color: textColorStyle
        }
      : {}

  return (
    <ChipRoot
      className={clsx(size, variant, className)}
      style={chipRootStyle}
      {...chipProps}
    >
      {iconSrc && <img className="icon" src={iconSrc} alt={iconAlt} />}
      <span className="label">{children}</span>
    </ChipRoot>
  )
}
